import type { FC } from 'react';
import type { LineProps } from './index';

export const TransparentRectLine: FC<LineProps> = ({ color, width, height }) => {
    return (
        <svg width={width} height="8" viewBox="0 0 90 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 4H16" stroke={color} strokeWidth={height} />
            <path d="M24 4H32" stroke={color} strokeWidth={height} />
            <path d="M40 4H48" stroke={color} strokeWidth={height} />
            <path d="M56 4H64" stroke={color} strokeWidth={height} />
            <path d="M72 4H80" stroke={color} strokeWidth={height} />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 2V6L1 6L1 2L7 2ZM8 1V2V6L8 7H7L1 7H0V6V2V1H1H7H8ZM23 2V6L17 6V2L23 2ZM24 1V2V6V7H23L17 7H16V6V2V1H17H23H24ZM39 6V2L33 2V6L39 6ZM40 2V1H39H33H32V2V6V7H33L39 7H40V6V2ZM55 2V6L49 6V2L55 2ZM56 1V2V6V7H55L49 7H48V6V2V1H49H55H56ZM71 6V2L65 2V6L71 6ZM72 2V1H71H65H64V2V6V7H65L71 7H72V6V2ZM87 2V6L81 6V2L87 2ZM88 1V2V6V7H87L81 7H80V6V2V1H81H87H88Z"
                fill={color}
            />
        </svg>
    );
};
